import { getDevStackMode } from '../common/devStackMode';

enum WebSocketApiUrl {
    dev = 'wss://oa8a69v97h.execute-api.eu-west-1.amazonaws.com/dev/',
    prod = 'wss://mslyncooy2.execute-api.eu-west-1.amazonaws.com/dev/',
    local = 'http://localhost:443',
}

/**
 * Set this constant to `true` in order to redirect to the local websocket server during local development.
 * NB: The local websocket server is implemented in the Joko AI codebase at `testScripts/localWebsocketServer.ts`, see instructions in the file.
 */
export const IS_JOKO_AI_LOCAL_WEBSOCKET_SERVER_ENABLED = false;

/**
 * This function returns the WebSocket API URL based on the environment.
 * If the IS_JOKO_AI_LOCAL_WEBSOCKET_SERVER_ENABLED constant is set to `true`, it will return the URL of the local WebSocket server implemented for local development of the Joko AI backend service.
 */
export function getWebSocketApiUrl(): string {
    if (IS_JOKO_AI_LOCAL_WEBSOCKET_SERVER_ENABLED) return WebSocketApiUrl.local;
    return getDevStackMode() ? WebSocketApiUrl.dev : WebSocketApiUrl.prod;
}
